module.exports = __webpack_public_path__ + "static/media/AnnualLeave.95096192.svg";